import {TextValidator} from "react-material-ui-form-validator";
import localization from "../../../config/localization";
import React from "react";
import { FastField} from "formik";
import {ContentSelectionTables} from "./ContentSelectionTables";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@material-ui/core";

const FormView = (formikProps) => {
  const {values, handleChange, setFieldValue} = formikProps
  return (
    <div>
      <TextValidator
        style={{ width: "100%"}}
        label={localization.get('form.name')}
        name={"titleEs"}
        value={values.titleEs}
        onChange={handleChange}
        validators={['required']}
        errorMessages={[localization.get('validator.is_required')]}
      />

      <div style={{marginTop: 30}}>
        <br/>
        <FormControl style={{width: "100%", float: "left", position: "relative"}}>
          <h4>{localization.get('order.type')}</h4>
          <RadioGroup
            name="orderType"
            value={values.orderType}
            onChange={async event =>
              await setFieldValue('orderType', event.target.value)
            }
            style={{ width: "100%", float: "left", position: "relative", flexDirection: "row" }}
          >
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="manual" control={<Radio color="default" />} label={localization.get('order.manual')} />
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="alpha-asc" control={<Radio color="default" />} label={localization.get('order.alpha_asc')} />
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="alpha-desc" control={<Radio color="default" />} label={localization.get('order.alpha_desc')} />
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="created-asc" control={<Radio color="default" />} label={localization.get('order.created_asc')} />
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="created-desc" control={<Radio color="default" />} label={localization.get('order.created_desc')} />
            <FormControlLabel style={{ width: "fit-content", float: "left", position: "relative" }} value="weight" control={<Radio color="default" />} label={localization.get('order.weight')} />
          </RadioGroup>
        </FormControl>
        <br/>
        <br/>

        {/*//Using <FastField/> so that formik doesn't re render this component each time a form update occurs*/}
        <FastField name={'ignore'}>
          {({field, form}) => (
          <ContentSelectionTables
            removedContent={values.removedContent}
            selectedContent={values.selectedContent}
            onRemovedItemsChanged={(removedContent) => setFieldValue('removedContent', removedContent)}
            onSelectedItemsChanged={(selectedContent) => setFieldValue('selectedContent', selectedContent)}
            onOrderChange={async () => await setFieldValue('orderType', "manual")}
          />
          )}
        </FastField>


      </div>
    </div>
  )
}

export default FormView